import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import UserOrderDetailsForm from "../Orderdetails/UserOrderDetails/UserOrderDetailsForm";
import SignIn from "../../Pages/SignIn";
import SigninForm from "../SigninSignUpForms/SigninForm";

import "./NotLoggedInCheckout.css";
import SignUpForm from "../SigninSignUpForms/SignUpForm";
import ColorHelper from "../../Helpers/ColorHelper";
import FontHelper from "../../Helpers/FontHelper";
import { useLocation } from "react-router-dom";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function NotLoggedInCheckout({ printInstruction }) {
  const [value, setValue] = React.useState(0);
  const { state } = useLocation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        width: { xs: "100%", sm: "80%", md: "70%", lg: "50%" },
        margin: "auto",
        py: 5,
        px: 2,
      }}
      id="NotLoggedInCheckoutPage"
    >
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          sx={{
            borderRadius: "12px 12px 0px 0px",
            width: "fit-content",
            ".MuiTabs-scroller": {
              overflow: "auto !important",
            },
            button: {
              fontFamily: FontHelper.fRegular,
              color: ColorHelper.DarkGrey2,
              textTransform: "inherit",
              border: "1px solid #E4E7EC",
              fontSize: 16,
            },
            ".Mui-selected": {
              color: `${ColorHelper.WhiteColor} !important`,
              backgroundColor: ColorHelper.PrimaryColor,
              fontFamily: FontHelper.fBold,
              textTransform: "inherit",
              fontSize: 16,
            },
            ".MuiTabs-indicator": {
              color: ColorHelper.BlackColor,
              backgroundColor: ColorHelper.SecondaryColor,
            },
          }}
        >
          <Tab label="Sign in" {...a11yProps(0)} />
          <Tab label="Sign up" {...a11yProps(1)} />
          <Tab label="Guest Checkout" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0} className="LoginTabs" id="SigninTab">
        <SigninForm itsInTabs={true} />
      </TabPanel>
      <TabPanel value={value} index={1} className="LoginTabs">
        <SignUpForm itsInTabs={true} />
      </TabPanel>
      <TabPanel
        value={value}
        index={2}
        className="LoginTabs"
        id="UserOrderDetailsForm"
      >
        <UserOrderDetailsForm
          itsInTabs={true}
          selectedValue={state.selectionType}
          price={state.price}
          printInstruction={printInstruction}
        />
      </TabPanel>
    </Box>
  );
}
